import { useSelector } from 'react-redux';
import * as MobilePushLogService from 'services/messaging/mobile/log';

export const useMobilePushLogService = () => {
  const { token } = useSelector((store) => store.user_data);

  const fetchLogs = async (options = {}) => {
    const { error, payload } = await MobilePushLogService.read({ ...options, token });
    if (error) {
      return {
        logs: [],
        size: 0
      };
    }

    const {
      data: logs,
      meta: { size }
    } = payload;
    return { logs, size };
  };

  return { fetchLogs };
};
